import { usePost } from 'app/queryProvider';
import { IDeviceIssueVerifyResponse, TDeviceIssueType } from 'app/types/deviceIssue';

export const useVerifyDeviceIssue = () => {
  const mutation = usePost<Record<string, never>, IDeviceIssueVerifyResponse>();

  const verify = (issueType: TDeviceIssueType) =>
    mutation.mutateAsync({
      resource: { name: 'device-status' },
      url: `/verify/${issueType}`,
      data: {},
    });

  return { verify, isVerifying: mutation.isPending };
};
